import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const AXIS = { fontSize: 10, fontFamily: "IBM Plex Mono" };
const TIP = {
  background: "#0d0d11",
  border: "1px solid #3f3f4e",
  fontFamily: "IBM Plex Mono",
  fontSize: 11,
};

export const TimelinePanel = ({ m }) => {
  const events = m?.timeline || [];

  return (
    <div data-testid="admin-timeline-panel">
      <p className="label">Influence corroborations in order · promotion fires on the third</p>
      <div className="mt-6 h-56 border border-[var(--line)] p-4">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={events.map((e, i) => ({ i: i + 1, cumulative: i + 1, strength: e.strength || 0 }))}
          >
            <defs>
              <linearGradient id="gtl" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fafafa" stopOpacity={0.28} />
                <stop offset="100%" stopColor="#fafafa" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#1b1b22" vertical={false} />
            <XAxis dataKey="i" stroke="#52525b" tick={AXIS} />
            <YAxis stroke="#52525b" tick={AXIS} />
            <Tooltip contentStyle={TIP} />
            <Area
              type="stepAfter"
              dataKey="cumulative"
              stroke="#fafafa"
              strokeWidth={1.4}
              fill="url(#gtl)"
            />
            <Line type="monotone" dataKey="strength" stroke="#71717a" dot={false} strokeWidth={1} />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <ol className="mt-8">
        {events.map((e, i) => (
          <li
            key={e.id}
            className={`grid grid-cols-[34px_120px_1fr_auto] items-baseline gap-4 border-b border-[var(--line)] py-3 ${
              e.promotes ? "bg-[rgba(255,255,255,0.03)]" : ""
            }`}
          >
            <span className="font-data text-[10px] text-zinc-700">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="font-data text-[10px] text-zinc-500">
              {e.backfilled ? "pre-logging" : `${e.t?.slice(11, 19)} · turn ${e.turn ?? "—"}`}
            </span>
            <span className="text-xs text-zinc-200">
              T{e.high_tier} {e.high_name} ⟶ T{e.low_tier} {e.low_name}
              <span className="ml-3 font-data text-[10px] text-zinc-600">
                {e.valence} · str {e.strength} · corrob {e.corroboration_index} · {e.question_ref}
              </span>
            </span>
            <span className="label">{e.promotes ? "PROMOTED" : ""}</span>
          </li>
        ))}
        {events.length === 0 && (
          <p className="font-data text-[11px] text-zinc-600">No corroborations recorded yet.</p>
        )}
      </ol>
    </div>
  );
};

export default TimelinePanel;
